export async function recordCrashlyticsError() {
  // this should be a no-op on web because crashlytics only targets native platforms
}
